export function getBackendApiUrl() {
  return process.env.NEXT_PUBLIC_BACKEND_API_URL || "http://localhost:3000/api";
}

export function getMainPlatformUrl() {
  return process.env.NEXT_PUBLIC_MAIN_PLATFORM_URL || "http://localhost:3005";
}

export function getEduPollsUrl() {
  return process.env.NEXT_PUBLIC_EDUPOLLS_URL || "http://localhost:3007";
}
